import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #E5EAF1',
    borderRadius: '5px',
    boxSizing: 'border-box',
    height: '36px',
    padding: '0 0 0 16px',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    outline: 'none',
    background: 'white',

    '&::placeholder': {
      color: '#888888 !important'
    },

    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  }
}))

export default useStyles
